import React from 'react';
import { Menu, IconButton, IconRefreshLine } from '@instructure/ui';
import { usePlayerStore, getStore } from '../../../stores/StoreContext';
import { useState, useEffect, useRef } from 'react';

const JumpBack = () => {
  const PlayerStore = getStore('playerStore');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Listen to any changes in the stores...
  const isLive = usePlayerStore((state) => state.isLive);
  const duration = usePlayerStore((state) => state.duration);
  const currentTime = usePlayerStore((state) => state.currentTime);
  const showHoverControls = usePlayerStore((state) => state.showHoverControls);

  // Close menu when hover controls are hidden
  useEffect(() => {
    if (!showHoverControls && isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [showHoverControls, isMenuOpen]);

  const jumpBack = (seconds) => {
    const fromTime = isLive ? duration : currentTime;
    PlayerStore.jumpTo(fromTime - seconds);
  };

  const renderOptions = () => {
    // TODO: We will need to take into account the fact that HLS is not to date with the live video...
    const options = [];
    if (isLive ? duration : currentTime > 5) {
      options.push(
        <Menu.Item key="jump_5" value="5" onClick={() => handleMenuSelect(5)}>
          5 Seconds
        </Menu.Item>
      );
    }
    if (isLive ? duration : currentTime > 20) {
      options.push(
        <Menu.Item
          key="jump_20"
          value="20"
          onClick={() => handleMenuSelect(20)}
        >
          20 Seconds
        </Menu.Item>
      );
    }
    if (isLive ? duration : currentTime > 60) {
      options.push(
        <Menu.Item
          key="jump_60"
          value="60"
          onClick={() => handleMenuSelect(60)}
        >
          1 Minute
        </Menu.Item>
      );
    }
    if (isLive ? duration : currentTime > 120) {
      options.push(
        <Menu.Item
          key="jump_120"
          value="120"
          onClick={() => handleMenuSelect(120)}
        >
          2 Minutes
        </Menu.Item>
      );
    }
    if (isLive ? duration : currentTime > 300) {
      options.push(
        <Menu.Item
          key="jump_300"
          value="300"
          onClick={() => handleMenuSelect(300)}
        >
          5 Minutes
        </Menu.Item>
      );
    }
    if (isLive ? duration : currentTime > 600) {
      options.push(
        <Menu.Item
          key="jump_600"
          value="600"
          onClick={() => handleMenuSelect(600)}
        >
          10 Minutes
        </Menu.Item>
      );
    }

    return options;
  };

  const handleMenuToggle = (isOpen) => {
    setIsMenuOpen(isOpen);
  };

  const handleMenuSelect = (seconds) => {
    jumpBack(seconds);
    setIsMenuOpen(false);
  };

  return (
    <>
      {(isLive ? duration : currentTime > 5) && (
        <Menu
          placement="bottom"
          show={isMenuOpen}
          onToggle={handleMenuToggle}
          elementRef={(ref) => (menuRef.current = ref)}
          trigger={
            <IconButton
              as="span"
              size="small"
              margin="none none none x-small"
              screenReaderLabel="Jump video back a set amount of time"
            >
              <IconRefreshLine size="x-small" />
            </IconButton>
          }
        >
          {renderOptions()}
        </Menu>
      )}
    </>
  );
};

export default JumpBack;
